import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { FxRateDetails, FxRateResults } from '../../store/fee-quote';

@Component({
    selector: 'app-exchange-rate',
    templateUrl: './exchange-rate.component.html',
    styleUrls: ['./exchange-rate.component.scss'],
    standalone: false
})
export class ExchangeRateComponent {
  //   exchangeInfo: string[] = [];
  //   @Input() flow: string = '';
  //   @Input() label: any = '';
  //   @Input() currency: string = '';
  @Input() fxRateObj: FxRateResults;

  //   private _exchangeRate!: string
  //   @Input() public set exchangeRate(exchangeRate: string | number) {
  //     if (typeof exchangeRate === 'number') {
  //       this._exchangeRate = exchangeRate.toFixed(4)
  //     } else {
  //       this._exchangeRate = exchangeRate && parseFloat(exchangeRate).toFixed(4)
  //     }
  //   }
  //   public get exchangeRate() {
  //     return this._exchangeRate
  //   }

  //   constructor() { }

  // ngOnChanges(changes: SimpleChanges) {
  //   console.log('FxRate onChange', this.fxRateObj)
  // }

  //   getExchangeRate() {
  //     if (this.flow === 'withdraw') {
  //       return [ `1.00 USD = ${this.exchangeRate} ${this.currency}` , `*1.00 USDC = 1.00 USD` ]
  //     } else {
  //       return [`${this.exchangeRate} USD = 1.0000 ${this.currency}` , `*1.00 USDC = 1.00 USD`]
  //     }
  //   }

  // ngOnInit(): void {
  //   console.log('HWat is the fxRate on ng init', this.fxRateObj)
  // }

  // ngOnChanges(changes: SimpleChanges): void {
  //   console.log('Prev State', changes['fxRateObj']?.previousValue)
  //   console.log('Current State', changes['fxRateObj']?.currentValue)
  // }
}
